// extracted by mini-css-extract-plugin
module.exports = {"notfoundimg":"notfoundimg___k0GjW"};